"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { useAuthStore } from "@/lib/store/authStore";
import { normalizeRegisterError } from "./registerFormUtils";
import type { UsageMode } from "./registerFormTypes";
import { useRegisterForm } from "./useRegisterForm";
import { RegisterView } from "./RegisterView";

export default function RegisterClient() {
  const searchParams = useSearchParams();
  const { register, isAuthenticated, isLoading, error, clearError } =
    useAuthStore();
  const googleErrorHint = searchParams?.get("googleError") || "";
  const initialUsageMode: UsageMode =
    searchParams?.get("usageMode") === "INDIVIDUAL" ? "INDIVIDUAL" : "BUSINESS";
  const form = useRegisterForm(
    initialUsageMode,
    searchParams?.get("organizationName") || "",
    { register, clearError }
  );
  const { setValidationError } = form;

  useEffect(() => {
    if (isAuthenticated) window.location.href = "/dashboard";
  }, [isAuthenticated]);
  useEffect(() => {
    setValidationError(googleErrorHint);
  }, [googleErrorHint, setValidationError]);

  return (
    <RegisterView
      form={form}
      displayError={form.validationError || normalizeRegisterError(error)}
      isLoading={isLoading}
    />
  );
}
